<template>
  <transition mode="out-in" name="slide-down">
    <suspense>
      <Dashboard v-if="isAuthenticated" />
      <Home v-else/>

      <template #fallback>
        <ProgressSpinner />
      </template>
    </suspense>
  </transition>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { storeToRefs } from "pinia";

import { useAuthStore } from "@/stores/Auth";

const { isAuthenticated } = storeToRefs( useAuthStore() );

const Home = defineAsyncComponent( () => import( '@/components/PublicHome.vue' ) );
const Dashboard = defineAsyncComponent( () => import( '@/components/dashboard/Dashboard.vue' ) );
</script>
